import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { RouteDefine } from './index.tsx/RouteDefine';
import { authService } from '../services/auth.service';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = authService.isUserAuthenticated();

  if (!isAuthenticated) {
    // Redirect to setup connection page but save the attempted url
    return <Navigate to={`/${RouteDefine.setupConnection}`} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 